/*************************
 counter js start
 *************************/
(function($) {
    "use strict";
    $(document).ready(function () {
        $('.counts').counterUp({
            delay: 10,
            time: 1000
        });
    });
})(jQuery);

/*************************
 counter js end
 *************************/